import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ROLE } from '../models/auth';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  public userDetails: any;
  public userRole: string = '';

  constructor(private authService: AuthService) {
    this.getUserDetails();
  }

  private getUserDetails() {
    this.userDetails = this.authService.getUserInfo();
    this.userRole = this.authService.getUserRole();
  }

  public getOrgId(): string {
    return this.userDetails.orgId.trim();
  }

  public getEmail(): string {
    return this.userDetails.email?.trim();
  }

  public getName(): string {
    return this.userDetails.given_name?.trim();
  }

  public getUserRole(): string {
    return this.userRole;
  }

  public getOrgName(): string {
    return this.authService.orgList.find((org) => org.orgId === this.getOrgId())?.orgName || '';
  }

  public isNflAdmin(): boolean {
    return this.userRole === ROLE.NFL_ADMIN;
  }
}
